import React from 'react';

import { FlagsProvider } from '@atlaskit/flag/flags-provider';
import UFOSegment from '@atlaskit/react-ufo/ufo-segment';

import { PageSegmentLoadEnd } from '@confluence/browser-metrics/entry-points/PageSegmentLoadEnd.ts';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart.ts';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData.ts';

import { useSessionSafeDwellTime } from './utils/useSessionSafeDwellTime.ts';
import { ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD } from './perf.config.ts';
import { AdvancedSearchPage, AdvancedSearchContainer, AdvancedSearchResults } from './styled.tsx';
import { SearchResultList } from './SearchResult/List/SearchResultList.tsx';
import { SmartAnswers } from './SmartAnswers/SmartAnswers.tsx';
import { AutocorrectionComponent } from './SearchResult/Autocorrection/Autocorrection.tsx';
import { HorizontalFilters } from './Filters/HorizontalFilterPane/index.ts';
import { PageLoadEndEvent } from './PageLoadEndEvent.tsx';
import { HorizontalFilterWrapper } from './Filters/HorizontalFilterPane/styled.tsx';

const AdvancedSearchLayoutContent = () => {
	const { locale } = useSessionData();

	const isAutocorrectionEnabled = locale.split('-')[0] === 'en';

	useSessionSafeDwellTime();

	return (
		<AdvancedSearchPage data-testid="advanced-search-page">
			<HorizontalFilterWrapper>
				<HorizontalFilters />
			</HorizontalFilterWrapper>

			<AdvancedSearchContainer>
				<AdvancedSearchResults>
					<SmartAnswers />
					{!!isAutocorrectionEnabled && <AutocorrectionComponent />}
					<PageSegmentLoadStart metric={ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD} />
					<SearchResultList />
					<PageLoadEndEvent />
				</AdvancedSearchResults>
				<PageSegmentLoadEnd metric={ADVANCED_SEARCH_RESULT_SECTION_PAGE_SEGMENT_LOAD} />
			</AdvancedSearchContainer>
		</AdvancedSearchPage>
	);
};

export const AdvancedSearchLayout = (): React.JSX.Element => (
	<UFOSegment name="advanced-search-layout">
		<FlagsProvider>
			<AdvancedSearchLayoutContent />
		</FlagsProvider>
	</UFOSegment>
);
